<div class="content">
    <div class="craft-visual" showleft [showDelay]="60">
        <img ngSrc="/images/about/veyora-about-details.webp" fill
            alt="Veyora Fit fabric swatches and activewear seam details">
        <div class="material-note">
            <span>touch</span>
            <strong>buttery, breathable, resilient</strong>
        </div>
    </div>

    <div class="craft-copy">
        <p class="eyebrow" showright [showDelay]="80">Fabric-first thinking</p>
        <h2 showright [showDelay]="150">Every line starts with how it lives on the body.</h2>
        <p showright [showDelay]="220">We look for stretch that returns, waistbands that stay smooth, and textures that
            feel soft without losing structure. The goal is not to over-engineer the day, but to make movement feel
            easier inside it.</p>
        <div class="measurements" showright [showDelay]="290">
            <div>
                <strong>01</strong>
                <span>Support that holds without pressure</span>
            </div>
            <div>
                <strong>02</strong>
                <span>Colors made to layer beyond the workout</span>
            </div>
            <div>
                <strong>03</strong>
                <span>Seams placed for comfort, coverage, and flow</span>
            </div>
        </div>
    </div>
</div>
